module.exports = __webpack_public_path__ + "img/baleno-gls-deep-blue.065ee3aa.png";